<script lang="ts">
  import Tuile from './Tuile.svelte';

  let elementCarrousel: HTMLDivElement | undefined = $state();

  const versDirection = (direction: number) => {
    if (elementCarrousel) {
      const cardWidth = elementCarrousel.firstElementChild?.clientWidth || 0;
      elementCarrousel.scrollBy({
        left: direction * (cardWidth + 16),
        behavior: 'smooth',
      });
    }
  };

  const precedent = () => versDirection(-1);

  const suivant = () => versDirection(+1);
</script>

<div class="carrousel-tuiles">
  <div class="conteneur-tuiles" bind:this={elementCarrousel}>
    <Tuile
      illustration="/statique/assets/images/doctrine-homologation/icone-succes.svg"
      titre="Pédagogique"
      contenu="Pourquoi, quoi, quand, qui, comment ? L'homologation de sécurité a été pensée pour être accessible à tous."
      classe="tuile-presentation"
    />
    <Tuile
      illustration="/statique/assets/images/doctrine-homologation/icone-balance.svg"
      titre="Proportionnée"
      contenu="D'une démarche &quot;simplifiée&quot; à une démarche &quot;renforcée&quot;, l'homologation doit être adaptée à la criticité d'un système et à son exposition au risque."
      classe="tuile-presentation"
    />
    <Tuile
      illustration="/statique/assets/images/doctrine-homologation/icone-utilisateur.svg"
      titre="Adaptée à vos usages"
      contenu="Une homologation simplifiée pensée pour répondre à la diversité des contextes de mise en oeuvre de l'homologation de sécurité de vos systèmes d'homologation."
      classe="tuile-presentation"
    />
  </div>
  <div class="conteneur-actions">
    <button class="precedent" onclick={precedent}>Précédent</button>
    <button class="suivant" onclick={suivant}>Suivant</button>
  </div>
</div>

<style>
  .conteneur-tuiles {
    --espacement: 16px;
    display: flex;
    overflow-x: auto;
    gap: var(--espacement);
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .conteneur-tuiles::-webkit-scrollbar {
    display: none;
  }

  :global(.tuile-presentation:first-of-type) {
    margin-left: var(--espacement);
  }

  :global(.tuile-presentation:last-of-type) {
    margin-right: var(--espacement);
  }

  :global(.tuile-presentation) {
    box-sizing: border-box;
    scroll-snap-align: center;
    flex-shrink: 0;
    width: calc(100vw - 60px);
    max-width: 266px;
  }

  .conteneur-actions {
    display: flex;
    margin-top: 32px;
    justify-content: center;
    padding: 0 var(--espacement);
    gap: 24px;
  }

  .conteneur-actions button {
    background: none;
    border: none;
    color: white;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .conteneur-actions .precedent:before,
  .conteneur-actions .suivant:after {
    content: url(/statique/assets/images/fleche_gauche_bleue.svg);
    display: flex;
    width: 24px;
    height: 24px;
    filter: brightness(0) invert(1);
    line-height: 28px;
  }

  .conteneur-actions .suivant:after {
    transform: rotate(180deg);
  }

  .conteneur-actions button:hover {
    text-decoration: underline;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  @media screen and (min-width: 577px) {
    .conteneur-tuiles {
      --espacement: 24px;
    }
  }

  @media screen and (min-width: 1247px) {
    .conteneur-actions {
      display: none;
    }

    :global(.tuile-presentation:first-of-type) {
      margin-left: 0;
    }

    :global(.tuile-presentation:last-of-type) {
      margin-right: 0;
    }
  }
</style>
